module.exports = __webpack_public_path__ + "img/x-with-cicle.5801623b.svg";